import { atom } from 'recoil';
import { UserListType } from '../types/UserType';

export const UserListState = atom<UserListType>({
  key: 'UserListState',
  default: {
    list: null,
  },
});
